/* LES AFFICHES QUI VONT AVEC : onglets, filtres, et défilement sans fin.
 *
 * ⛔ CHAQUE RAIL EST UNE INTERROGATION, PAS UNE LISTE. Le Liquid ne pose que la question (les
 * facettes dans `data-marie-requete`) ; les cartes arrivent de la vitrine, page par page, avec
 * exactement le même HTML que le serveur rend en collection. Une affiche ajoutée au catalogue
 * entre dans les réponses sans qu'on recalcule quoi que ce soit.
 *
 * ⛔ ON NE RÉÉCRIT PAS LA CARTE EN JAVASCRIPT. La carte produit est un snippet (badges, prix
 * barré, cadre, survol) : la refaire ici en ferait une seconde version qui finirait par
 * diverger de la vraie. On insère le HTML rendu par `templates/collection.rail.liquid`.
 *
 * ⚠️ UN RAIL CACHÉ N'A NI LARGEUR NI IMAGES, et ne doit rien demander. `hidden` le rend à 0 x 0
 * sans erreur : mesuré avant affichage, il répond toujours « pas besoin de charger », et le
 * navigateur ne va pas chercher ses vignettes. Le premier chargement est donc déclenché par
 * l'AFFICHAGE du rail, jamais par le rendu de la page.
 */
(function () {
  'use strict';
  var bloc = document.getElementById('marie');
  if (!bloc || bloc.dataset.marieArme === '1') return;
  bloc.dataset.marieArme = '1';

  var base = bloc.dataset.marieBase || '';
  var sauf = bloc.dataset.marieSauf || '';

  /* ⛔ LES TROIS LISTES DE COULEUR SE SEPARENT ICI, ET NULLE PART AILLEURS. Une facette
     `filter.v.t.shopify.color-pattern=A&…=B` est un OU : une affiche qui porte a la fois ma
     couleur et une couleur d'accord repond aux DEUX interrogations, et Shopify n'offre aucun
     NON. Mesure du 19/08 sur « l'amphore sous l'arche » (Orange, accord beige/jaune/marron) :
     4 des 6 premieres affiches etaient les memes sous « Couleurs assorties » et sous son
     filtre d'accord. C'est le defaut qu'Adrien a vu en capture.
     Priorite : MEME d'abord, puis ACCORD sur ce qui reste, puis CONTRASTE sur le reste. */
  var listeDe = function (s) { return String(s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); };
  var MIEN = listeDe(bloc.dataset.marieMien);
  var ACCORD = listeDe(bloc.dataset.marieAccord);
  var INTERDITS = { 'couleur-accord': MIEN, 'couleur-contraste': MIEN.concat(ACCORD) };

  /* ⛔⛔ « MEME COULEUR » DEMANDE UNE VRAIE PARENTE, PAS UNE COULEUR EN COMMUN (Adrien,
     09/09/2026, sur « Le nageur au large » : « je ne vois pas en quoi ce sont les memes couleurs ?
     Sous pretexte qu'il y a un peu de bleu ? Ce n'est pas bon »).

     Une facette Shopify a plusieurs valeurs est un OU : partager UNE couleur suffisait a
     repondre. Mesure du jour sur son rail :

       Le nageur au large                     blue
       Terrasse mediterraneenne sur la mer    beige, green, blue
       La cour aux agaves face a la mer       green, blue, orange
       Le chat dans la mousse                 blue, pink, white

     Une terrasse terracotta remontait donc dans le rail d'une affiche entierement bleue, parce
     qu'elle porte un peu de ciel. Meme defaut que celui deja paye sur le FILTRE des collections,
     et `importer.py` le raconte : « un renard rouille sortait dans le filtre Bleu a cause des
     papiers derriere lui ».

     ⛔⛔ ET LA REGLE NE PEUT PAS S'APPUYER SUR L'ORDRE DE LA FACETTE. Premier correctif du meme
     jour : « la premiere couleur du candidat doit etre une des miennes », en supposant que la
     facette est ecrite par dominance decroissante. MESURE sur 40 affiches a trois couleurs, en
     comparant la facette a `couleurs.py` (l'instrument de l'import) : la premiere de la facette
     est la premiere mesuree dans 18 cas sur 40. L'ordre ne dit PAS la dominance, et une regle
     posee dessus aurait ecarte au hasard.

     ⚠️ CE QUI SE MESURE SANS ORDRE, C'EST LA PART. Le candidat doit consacrer au moins la MOITIE
     de ses couleurs aux miennes : une affiche a trois couleurs dont une seule est la mienne
     n'est pas « de la meme couleur », elle en a un peu. Une affiche bleue et blanche en face
     d'une affiche bleue, oui. Ce test ne depend d'aucun ordre, donc d'aucune supposition. */
  function horsDeMaCouleur(cle, carte) {
    if (cle !== 'couleur-meme' || !MIEN.length) return false;
    /* ⚠️ UNE CARTE SANS ATTRIBUT RESTE : mieux vaut un voisin discutable qu'un rail vide le jour
       ou la vue change de forme. C'est deja la regle de `ecartee` juste dessous. */
    var brut = carte.getAttribute && carte.getAttribute('data-couleurs');
    if (brut === null || brut === undefined) return false;
    var siennes = listeDe(brut);
    if (!siennes.length) return false;
    var communes = 0;
    for (var i = 0; i < siennes.length; i += 1) {
      if (MIEN.indexOf(siennes[i]) !== -1) communes += 1;
    }
    return communes * 2 < siennes.length;
  }

  function ecartee(cle, carte) {
    if (horsDeMaCouleur(cle, carte)) return true;
    var interdits = INTERDITS[cle];
    if (!interdits || !interdits.length) return false;
    /* ⚠️ L'ATTRIBUT EST SUR L'ENVELOPPE `.marie__carte`, posee par `collection.marie.liquid`.
       Une carte sans attribut n'est pas ecartee : mieux vaut un doublon qu'un rail vide le
       jour ou la vue change de forme. */
    var brut = carte.getAttribute && carte.getAttribute('data-couleurs');
    if (brut === null || brut === undefined) return false;
    var siennes = listeDe(brut);
    for (var i = 0; i < siennes.length; i += 1) {
      if (interdits.indexOf(siennes[i]) !== -1) return true;
    }
    return false;
  }
  var onglets = [].slice.call(bloc.querySelectorAll('[data-marie-onglet]'));
  var panneaux = [].slice.call(bloc.querySelectorAll('[data-marie-pan]'));
  var rails = [].slice.call(bloc.querySelectorAll('[data-marie-liste]'));

  var etat = {};   /* par clé de rail : page, fini, occupé, vus */

  function majFleches(rail) {
    var piste = rail.querySelector('[data-marie-piste]');
    var g = rail.querySelector('[data-marie-prec]');
    var d = rail.querySelector('[data-marie-suiv]');
    if (!piste || !g || !d) return;
    var e = etat[rail.dataset.marieListe];
    var reste = piste.scrollWidth - piste.clientWidth;
    g.disabled = piste.scrollLeft <= 4;
    /* ⚠️ LA FLÈCHE DROITE RESTE ACTIVE TANT QU'IL RESTE DES PAGES. L'éteindre au bout de la
       piste dirait « vous avez tout vu » alors qu'il reste des centaines d'affiches. */
    d.disabled = e && e.fini && piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 4;
  }

  /* ⛔ EPUISER LA PREMIERE INTERROGATION NE FERME PAS LE RAIL : il bascule sur son repli
     (`data-marie-repli`), qui est la piece seule. C'est ce qui permet a l'onglet couleur de
     croiser couleur ET piece sans vider la piste. Les affiches deja posees restent dans
     `e.vus`, donc le repli n'en repose aucune. Un rail sans repli finit comme avant. */
  function finir(rail, e) {
    var repli = rail.dataset.marieRepli || '';
    if (repli && !e.repli) { e.repli = true; e.page = 0; e.vides = 0; return; }
    e.fini = true;
  }

  function charger(rail) {
    var cle = rail.dataset.marieListe;
    /* ⛔ L'AFFICHE REGARDEE S'EXCLUT ICI, et nulle part ailleurs. `sauf=` en parametre d'URL
       est INERTE : mesure du 19/08, la vue rend la meme premiere affiche avec et sans. Le
       navigateur, lui, sait de quelle fiche il vient. */
    var e = etat[cle];
    if (!e) { e = etat[cle] = { page: 0, fini: false, occupe: false, vus: {} };
              if (sauf) e.vus[sauf] = true; }
    if (e.occupe || e.fini) return;
    e.occupe = true;
    e.page += 1;
    var piste = rail.querySelector('[data-marie-piste]');
    var q = ((e.repli ? rail.dataset.marieRepli : rail.dataset.marieRequete) || '').replace(/^&/, '');
    /* ⛔ `view=marie`, PAS `view=rail` + UN DRAPEAU. Un parametre que Shopify ne connait pas
       n'arrive pas jusqu'a `request.url` dans une vue de collection : mesure du 19/08, la vue
       rendait exactement la meme chose avec et sans. `view` est un parametre qu'il traite. */
    var url = base + '?' + q + '&view=marie&page=' + e.page;
    /* Pas d'en-tête Accept : sur une URL de collection, Shopify négocie le contenu et peut
       renvoyer autre chose que la vue demandée. */
    fetch(url, { cache: 'no-cache' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var t = document.createElement('div');
        t.innerHTML = html;
        /* ⛔ UN SEUL POINT DE SORTIE. Trois `e.fini = true` epars annulaient la bascule :
           le premier passait au repli, le suivant fermait aussitot le rail. On note, et on
           tranche une fois, en bas. */
        var doitFinir = false;
        if (t.querySelector('[data-rail-fin]')) doitFinir = true;
        var cartes = [].slice.call(t.children).filter(function (n) {
          return n.nodeType === 1 && !n.hasAttribute('data-rail-fin');
        });
        if (!cartes.length) { finir(rail, e); return; }
        /* ⛔ JAMAIS DEUX FOIS LA MÊME AFFICHE. Les pages se chevauchent dès que le classement
           bouge entre deux requêtes. Une page entièrement connue n'arrête PAS la pagination :
           la suivante peut apporter du neuf. */
        /* ⚠️ L'ENVELOPPE ET LES PASTILLES VIENNENT DU SERVEUR (`&pastilles=1`), pas d'ici :
           les fabriquer en JavaScript en ferait une deuxieme version de la carte. Le handle
           est porte par le lien A l'INTERIEUR de l'enveloppe, pas par l'enveloppe. */
        var pose = 0;
        cartes.forEach(function (c) {
          if (ecartee(cle, c)) return;
          var lien = c.matches('[data-handle]') ? c : c.querySelector('[data-handle]');
          var h = lien && lien.getAttribute('data-handle');
          if (h) { if (e.vus[h]) return; e.vus[h] = true; }
          piste.appendChild(c);
          pose += 1;
        });
        /* ⚠️ UN FILTRE TRES SELECTIF NE DOIT PAS TOURNER SANS FIN. Sur une affiche dont la
           couleur est tres repandue, plusieurs pages d'affilee peuvent etre entierement
           ecartees. On s'arrete au bout de cinq pages steriles : au-dela, il n'y a plus rien a
           montrer et on demanderait au serveur des centaines de pages pour rien. */
        if (pose === 0) { e.vides = (e.vides || 0) + 1; if (e.vides >= 5) doitFinir = true; }
        else e.vides = 0;
        if (doitFinir) finir(rail, e);
      })
      .catch(function () { e.fini = true; })
      .then(function () { e.occupe = false; majFleches(rail); apresCoup(rail); });
  }

  /* ⚠️ APRÈS CHAQUE FOURNÉE, ON REGARDE S'IL EN FAUT UNE AUTRE : sur un grand écran, vingt
     cartes ne remplissent pas toujours la piste, et le rail resterait court sans jamais
     déclencher le défilement qui aurait chargé la suite. */
  function apresCoup(rail) {
    var piste = rail.querySelector('[data-marie-piste]');
    var e = etat[rail.dataset.marieListe];
    if (!piste || !e || e.fini || e.occupe) return;
    if (piste.scrollWidth < piste.clientWidth * 2) charger(rail);
  }

  function montrerRail(panneau, cle) {
    [].slice.call(panneau.querySelectorAll('[data-marie-liste]')).forEach(function (r) {
      var actif = r.dataset.marieListe === cle;
      if (actif) { r.removeAttribute('hidden'); charger(r); majFleches(r); }
      else r.setAttribute('hidden', '');
    });
    [].slice.call(panneau.querySelectorAll('[data-marie-filtre]')).forEach(function (b) {
      var actif = b.dataset.marieFiltre === cle;
      b.classList.toggle('is-actif', actif);
      b.setAttribute('aria-pressed', actif ? 'true' : 'false');
    });
  }

  function montrerOnglet(quoi) {
    onglets.forEach(function (o) {
      var actif = o.dataset.marieOnglet === quoi;
      o.classList.toggle('is-actif', actif);
      o.setAttribute('aria-selected', actif ? 'true' : 'false');
      o.tabIndex = actif ? 0 : -1;
    });
    panneaux.forEach(function (pan) {
      var actif = pan.dataset.mariePan === quoi;
      if (actif) {
        pan.removeAttribute('hidden');
        [].slice.call(pan.querySelectorAll('[data-marie-liste]')).forEach(function (r) {
          if (!r.hasAttribute('hidden')) { charger(r); majFleches(r); }
        });
      } else pan.setAttribute('hidden', '');
    });
  }

  onglets.forEach(function (o, i) {
    o.addEventListener('click', function () { montrerOnglet(o.dataset.marieOnglet); });
    o.addEventListener('keydown', function (e) {
      var pas = e.key === 'ArrowRight' ? 1 : (e.key === 'ArrowLeft' ? -1 : 0);
      if (!pas) return;
      e.preventDefault();
      var suiv = onglets[(i + pas + onglets.length) % onglets.length];
      montrerOnglet(suiv.dataset.marieOnglet);
      suiv.focus();
    });
  });

  panneaux.forEach(function (pan) {
    [].slice.call(pan.querySelectorAll('[data-marie-filtre]')).forEach(function (b) {
      b.addEventListener('click', function () { montrerRail(pan, b.dataset.marieFiltre); });
    });
  });

  rails.forEach(function (rail) {
    var piste = rail.querySelector('[data-marie-piste]');
    if (!piste) return;
    function pas() {
      var carte = piste.firstElementChild;
      var l = carte ? carte.getBoundingClientRect().width + 16 : 200;
      return Math.max(l, piste.clientWidth - l);
    }
    var g = rail.querySelector('[data-marie-prec]');
    var d = rail.querySelector('[data-marie-suiv]');
    if (g) g.addEventListener('click', function () { piste.scrollBy({ left: -pas(), behavior: 'smooth' }); });
    if (d) d.addEventListener('click', function () { piste.scrollBy({ left: pas(), behavior: 'smooth' }); });
    piste.addEventListener('scroll', function () {
      majFleches(rail);
      /* On charge DEUX LARGEURS D'ÉCRAN à l'avance, pour que le rail ne s'arrête jamais sous
         le doigt. */
      if (piste.scrollLeft + piste.clientWidth * 3 >= piste.scrollWidth) charger(rail);
    }, { passive: true });
    window.addEventListener('resize', function () { majFleches(rail); }, { passive: true });
  });

  /* ⛔ LE DECLENCHEUR NE DEPEND PLUS D'UN SEUL EVENEMENT. Premiere version : un
     IntersectionObserver, et lui seul. Mesure du 19/08 sur la fiche « toits de zinc » : bloc
     arme, attributs corrects, point de terminaison qui repond 20 cartes a la main, et POURTANT
     zero carte inseree, de facon intermittente d'un chargement a l'autre. Un declencheur qu'on
     ne peut pas observer depuis l'exterieur ne se debogue pas : on le remplace par une
     condition qu'on peut lire a tout moment.

     Deux filets, et un troisieme qui repare :
       1. au chargement, si le bloc est deja a moins de deux ecrans ;
       2. a chaque defilement, tant qu'il ne l'est pas ;
       3. une verification qui rattrape un rail visible reste vide, quoi qu'il soit arrive. */
  var demarre = false;
  function demarrer() {
    if (demarre) return;
    demarre = true;
    var ouvert = onglets[0] && onglets[0].dataset.marieOnglet;
    if (ouvert) montrerOnglet(ouvert);
  }
  function proche() {
    var r = bloc.getBoundingClientRect();
    return r.top < window.innerHeight * 2 && r.bottom > -window.innerHeight;
  }
  function peutDemarrer() {
    if (!proche()) return;
    demarrer();
    window.removeEventListener('scroll', peutDemarrer);
  }
  window.addEventListener('scroll', peutDemarrer, { passive: true });
  peutDemarrer();

  /* ⚠️ LE RATTRAPAGE. Un rail visible et vide est une panne, pas un etat : on redemande. Trois
     essais espaces, puis on arrete pour ne pas boucler sur une collection reellement vide. */
  var essais = 0;
  var rattrapage = setInterval(function () {
    essais += 1;
    if (essais > 3) { clearInterval(rattrapage); return; }
    if (!proche()) return;
    demarrer();
    rails.forEach(function (r) {
      if (r.hasAttribute('hidden')) return;
      var piste = r.querySelector('[data-marie-piste]');
      var e = etat[r.dataset.marieListe];
      if (piste && !piste.children.length && (!e || (!e.occupe && !e.fini))) charger(r);
    });
  }, 1500);
})();
